import { render } from "./Flex.vue?vue&type=template&id=e2b447f2"
import script from "./Flex.vue?vue&type=script&lang=js"
export * from "./Flex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__